import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sales-request-add",
  "use": "icon-sales-request-add-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sales-request-add\">\n<circle cx=\"7.5\" cy=\"7.5\" r=\"7.5\" fill=\"white\" />\n<line x1=\"7.5\" y1=\"4\" x2=\"7.5\" y2=\"11\" stroke=\"#00228C\" />\n<line x1=\"11\" y1=\"7.5\" x2=\"4\" y2=\"7.5\" stroke=\"#00228C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol